document.addEventListener("DOMContentLoaded", function () {
  const fitment_details = document.getElementById("product-fitment-details");
  const table = document.getElementById("fitment--table");
  const viewMoreBtn = document.getElementById("viewMoreBtn");
  const hiddenRows = document.querySelectorAll(".hidden-row");
  if (table) {
    const rows = table.getElementsByTagName("tr");
    let isHidden = true;

    // Toggle hidden rows on button click
    if (viewMoreBtn) {
      viewMoreBtn.addEventListener("click", function (e) {
        e.preventDefault();
        for (let i = 0; i < hiddenRows.length; i++) {
          hiddenRows[i].style.display = isHidden ? "table-row" : "none";
        }
        viewMoreBtn.textContent = isHidden ? "View Less" : "View More";
        isHidden = !isHidden;
        if (!isHidden) {
          viewMoreBtn.classList.add("view-less");
        } else {
          viewMoreBtn.classList.remove("view-less");
          fitment_details.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    }
  }

  $(".cm_verify-fitment_change").text("Change Vehicle");
  $(".product .cm_verify-fitment_change").after(
    '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
  );

  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
  }, 700);
  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
  }, 1500);
  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
  }, 2500);
  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
  }, 3500);
  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
  }, 4500);
  $("body").on("change", function () {
    setTimeout(function () {
      $(".cm_verify-fitment_change").text("Change Vehicle");
      if ($(".view-matching-products").length < 1) {
        $(".product .cm_verify-fitment_change").after(
          '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
        );
      }
    }, 500);
  });
  setTimeout(function () {
    $(".cm_verify-fitment_change").text("Change Vehicle");
    if ($(".view-matching-products").length < 1) {
      $(".product .cm_verify-fitment_change").after(
        '<a class="view-matching-products" href="/collections/all">View Products that fit your vehicle</a>'
      );
    }
    if ($(".cm_verify-fitment__yes").length) {
      $(".remove-facet-cookies").hide();
    } else {
      $(".remove-facet-cookies").show();
    }
  }, 1500);
  $("#choose_vehicle").on("click", function (event) {
    event.preventDefault();
    $(".add-vehicle").click();
  });
  $(document).on("click", function () {
    setTimeout(function () {
      $(".cm_verify-fitment_change").text("Change Vehicle");
      if ($(".cm_verify-fitment__yes").length) {
        $(".remove-facet-cookies").hide();
      } else {
        $(".remove-facet-cookies").show();
      }
    }, 500);
  });
});
